import fetcher from "@/lib/fetcher";
import type { KeywordProfile } from "@/hooks/use-keyword-profiles";

export async function search(
  profiles: KeywordProfile[],
  { isForce = false }: { isForce?: boolean } = {},
) {
  const payload = profiles.map((p: any) => ({
    source: p.source,
    keywords: p.keywords,
    settings: p.settings ?? {},
    force: isForce,
  }));

  return fetcher.post("/api/search/all", payload);
}

export async function get_all() {
  return fetcher.get("/api/search/get");
}

export async function get_detail(job_id: string) {
  return fetcher.get(`/api/search/detail/${job_id}`);
}